import script from "./InternalSignalingHint.vue?vue&type=script&setup=true&lang=ts"
export * from "./InternalSignalingHint.vue?vue&type=script&setup=true&lang=ts"

import "./InternalSignalingHint.vue?vue&type=style&index=0&id=ef3773e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef3773e0"]])

export default __exports__